import { createGlobalStyle } from "styled-components";
import nunitoExtraLight from "../assets/fonts/Nunito-ExtraLight.ttf";
import nunitoLight from "../assets/fonts/Nunito-Light.ttf";
import nunitoRegular from "../assets/fonts/Nunito-Regular.ttf";
import nunitoMedium from "../assets/fonts/Nunito-Medium.ttf";
import nunitoSemiBold from "../assets/fonts/Nunito-SemiBold.ttf";
import nunitoBold from "../assets/fonts/Nunito-Bold.ttf";
import nunitoExtraBold from "../assets/fonts/Nunito-ExtraBold.ttf";
import nunitoBlack from "../assets/fonts/Nunito-Black.ttf";

export const GlobalStyles = createGlobalStyle`
@font-face {
  font-family: 'Nunito';
  src: url(${nunitoExtraLight}) format('truetype');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoLight}) format('truetype');
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoRegular}) format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoMedium}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoSemiBold}) format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoBold}) format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoExtraBold}) format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  src: url(${nunitoBlack}) format('truetype');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    box-sizing: border-box
  }

  body {    
    background: linear-gradient(135deg, #F4EFF9 0%, #DAE0ED 100%);
    font-family: ${({ theme }) => theme.fonts?.body || "sans-serif"};
    color: ${({ theme }) => theme.colors?.text || "#000000"};
    font-size: 0.9rem;
  }

  #root{
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing?.medium || "20px"};
    padding: ${({ theme }) => theme.padding?.body || "20px"};

    @media (max-width: 768px) {
          padding: ${({ theme }) => theme.padding.small};
        }
  }

  :root {
    --primary-color: ${({ theme }) => theme.colors.primary};
    --text-color: ${({ theme }) => theme.colors.text};
    --border-radius: ${({ theme }) => theme.borderRadius.medium};
    --font-family: ${({ theme }) => theme.fonts.body};
  }

  button, input, textarea, select {
    font-family: inherit;
  }

  ::selection {
    background: var(--primary-100);
  }

  /* скроллбар */
  ::-webkit-scrollbar {
    width: 8px;       
    height: 8px;      
  }

  /* Фон дорожки */
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 8px;
  }

  /* Ползунок */
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 8px;
  }

  /* Ползунок при наведении */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }


 /* Сбросы стилей для PrimeReact */
  @layer reset, primereact, my-customizations;
 
  @layer reset {
    .p-button , .p-inputtext {
      padding:0;
    }
  }

  /* кастомные стили для PrimeReact */
  @layer my-customizations {
    .p-component {
      font-family: ${({ theme }) => theme.fonts.body};      
      font-size: 0.9rem;    
    }

    .p-button {
      background-color: ${({ theme }) => theme.colors.primary};
      border-radius: ${({ theme }) => theme.borderRadius.medium};
      border:none;
      font-family: ${({ theme }) => theme.fonts.body};
      font-weight: 500;
      padding: ${({ theme }) => theme.padding.button};
      color: ${({ theme }) => theme.colors.white};
      justify-content: center;
      transition: all 0.2s;    

      &:hover {
        opacity:0.8;
      }
    }

    .p-button-secondary {
      background-color: ${({ theme }) => theme.colors.secondary};
      padding: ${({ theme }) => theme.padding.small};
      border-radius: ${({ theme }) => theme.borderRadius.medium};

      &:hover {
        background-color: var(--primary-100);
      }
    }

    .p-button-text {
      background-color: transparent;
      padding: ${({ theme }) => theme.padding.small};
      border-radius: ${({ theme }) => theme.borderRadius.large};

      &:hover {
        background-color: ${({ theme }) => theme.colors.secondary};
      }
    }

    .p-button-outlined {
      background-color: transparent;
      border: 1px solid ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.text};

      &:hover {
        background-color: var(--primary-100);
      }
    }

    .p-button-outlined.p-button-secondary {
      border: 1px solid var(--surface-300);

      &:hover {
        border: 1px solid transparent;
      }
    }

    .p-button-danger {
      background-color: #cc393d !important;
    }

    .p-button-label {
      font-weight: 500;
    }
    
    .p-inputtext {
      border-radius: ${({ theme }) => theme.borderRadius.medium};
      font-family: ${({ theme }) => theme.fonts.body};
      color: ${({ theme }) => theme.colors.text};
      padding: ${({ theme }) => theme.padding.small};
      background-color: transparent;
    }

    .p-inputtext::placeholder {
      color: ${({ theme }) => theme.colors.darkGrey};
      opacity: 1; 
    }
    
    .p-datatable {
      background: white;
      box-shadow: ${({ theme }) => theme.shadow.medium};
      border: 1px solid ${({ theme }) => theme.colors.secondary};
      border-radius: 10px;
      font-family: ${({ theme }) => theme.fonts.body};
      font-weight: 500;
      overflow: hidden;
    }

    .p-datatable .p-datatable-thead > tr > th {
      background-color: ${({ theme }) => theme.colors.lightGrey}; 
      color: ${({ theme }) => theme.colors.text}; 
      border: none;
      font-weight: 500;
      padding: 5px 8px;
    }

    .p-datatable .p-datatable-tbody > tr > td {
      border:none;
      padding: 5px 8px;
      color: ${({ theme }) => theme.colors.text};
    }

    .p-paginator .p-paginator-pages .p-paginator-page {
      min-width: 2rem; 
      height: 2rem;
      font-size: 0.9rem; 
    }

    .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
      background: ${({ theme }) => theme.colors.secondary};
      border-color: ${({ theme }) => theme.colors.secondary};
    }

    .p-sidebar {
      width: 100%;
      background: linear-gradient(135deg, #F4EFF9 0%, #DAE0ED 100%);
    }

    .p-sidebar-header {
      padding: ${({ theme }) => theme.padding.small};
    }

    .p-sidebar-close:enabled:hover, .p-sidebar-icon:enabled:hover {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.primary};
    }

    .p-sidebar-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: ${({ theme }) => theme.spacing.small};
      padding: ${({ theme }) => theme.padding.small};
      justify-content: center;
    }
    
    .p-icon-field-left .p-inputtext {
      padding-left: 2.3rem !important; 
    }

    .p-icon-field > .p-input-icon {
      position: absolute;
      top: 50%;
      margin-top: -0.6rem;
    }

    .p-menuitem-content {
      display: flex;
      gap: ${({ theme }) => theme.spacing.small};
      padding: 2.5px 10px 2.5px 5px;
      align-items: center;
      color: ${({ theme }) => theme.colors.text};
      font-weight: 400;
      cursor: pointer;
    }

    .p-tag {
      border-radius: ${({ theme }) => theme.borderRadius.medium};
      font-weight: 500;
      color: ${({ theme }) => theme.colors.text};
      padding: 4px 10px;
    }

    .p-tag-success {
      background-color: ${({ theme }) => theme.colors.success};
    }

    .p-tag-danger {
      background-color: ${({ theme }) => theme.colors.error};
    }

    .p-tag-warning {
      background-color: ${({ theme }) => theme.colors.warning};
    }

    .p-tag-info {
      background-color: ${({ theme }) => theme.colors.info};
    }

    .p-tag-secondary {
      background-color: ${({ theme }) => theme.colors.secondary};
    }

    .p-tag- {
      background-color: var(--primary-100);
    }

    .p-dialog {
      border-radius: ${({ theme }) => theme.borderRadius.large};
      box-shadow: ${({ theme }) => theme.shadow.large};
  }

    .p-dialog-header {
      color: ${({ theme }) => theme.colors.text};
      padding: 30px 30px 0 30px;
      border-top-right-radius: ${({ theme }) => theme.borderRadius.large};
      border-top-left-radius: ${({ theme }) => theme.borderRadius.large};
    }

    .p-dialog-content {
      color: ${({ theme }) => theme.colors.text};
      padding: 20px 30px 20px 30px;
    }

    .p-dialog-footer {
      color: ${({ theme }) => theme.colors.text};
      padding: 0 30px 30px 30px;
      border-bottom-right-radius: ${({ theme }) => theme.borderRadius.large};
      border-bottom-left-radius: ${({ theme }) => theme.borderRadius.large};
  }
    
  }

  .p-column-filter-overlay-menu .p-column-filter-buttonbar {
    padding: 1rem;
  }

  .p-column-filter-overlay-menu .p-column-filter-constraint {
    padding: 1rem;
  }

  .p-column-filter-overlay-menu .p-column-filter-add-rule {
   padding: 0.75rem 1rem;
  }

  .p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-matchmode-dropdown {
   border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  .p-dropdown {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  .p-multiselect {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  .p-column-filter-buttonbar {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
  }

  .p-column-filter-operator {
    display: none !important;
  }

  .p-column-filter-add-rule {
    display: none !important;
  }

  .p-dropdown .p-dropdown-label.p-placeholder {
    color: #6b7280 !important;
  }

  .p-picklist .p-picklist-header {
    padding: 1rem !important;
  }
`;
